import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import api from "../../services/api";

const statusMap = {
  undefined: "Неопознанный",
  new: "Новый",
  layouting_awaiting: "Ожидает компоновки",
  layouting: "Компонуется",
  layouting_completed: "Компоновка завершена",
  printing_awaiting: "Ожидает печати",
  printing: "Печатается",
  printing_completed: "Печать завершена",
  cutting_awaiting: "Ожидает резки",
  cutting: "Режется",
  cutting_completed: "Резка завершена",
  packaging_awaiting: "Ожидает упаковки",
  packaging: "Упаковывается",
  packaging_completed: "Упаковка завершена",
};

export default function StatusHistoryModal({ show, onClose, position }) {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);

  useEffect(() => {
    if (!show || !position) return;

    const fetchHistory = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/orders/status-history/${position.orderPositionId}`);
        setRecords(res.data?.records || []);
      } catch (err) {
        console.error("Ошибка загрузки истории статусов", err);
      }
      setLoading(false);
    };

    fetchHistory();
  }, [show, position]);

  if (!position) return null;

  const createdAt = new Date(position.createdAt).toLocaleString();

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>История статусов</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* --- Верхняя часть --- */}
        <div className="d-flex mb-3">
          <img
            src={position.image}
            alt={position.article}
            style={{ width: 130, height: 130, objectFit: "contain" }}
            className="rounded border me-3"
          />

          <div>
            <h5>{position.name}</h5>
            <div className="text-muted">Артикул: {position.article}</div>
            <div className="text-muted">Время заказа: {createdAt}</div>
            <div className="mt-2">
              Текущий статус: <strong>{statusMap[position.status] || position.status}</strong>
            </div>
          </div>
        </div>

        <hr />

        {/* --- История --- */}
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : records.length === 0 ? (
          <div className="text-center text-muted py-4">История отсутствует</div>
        ) : (
          <div className="timeline">
            {records.map((r, i) => (
              <div
                key={i}
                className="p-2 border rounded mb-2"
                style={{ background: "#fafafa" }}
              >
                <div>
                  <strong>{statusMap[r.status] || r.status}</strong>
                </div>

                <div className="text-muted">{new Date(r.creationTime).toLocaleString()}</div>

                {r.createdBy && (
                  <div className="text-primary">
                    Изменил: <strong>{r.createdBy}</strong>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
